// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"_e207ea7"};